module.exports = __webpack_public_path__ + "static/media/FUN88_Affiliate_Page_QRZalo.f128d7ee.jpg";